// src/utils/nivelTiers.js

export const NIVEL_TIERS = [
  { min: 1,   max: 4,        nome: "Bronze",     icone: "🥉", corPrincipal: "#8c5a2b", corBrilho: "#c98a4b" },
  { min: 5,   max: 14,       nome: "Prata",       icone: "🥈", corPrincipal: "#9e9e9e", corBrilho: "#d4d4d4" },
  { min: 15,  max: 29,       nome: "Ouro",        icone: "🥇", corPrincipal: "#d4af37", corBrilho: "#f5d76e" },
  { min: 30,  max: 49,       nome: "Platina",     icone: "💠", corPrincipal: "#5f9ea0", corBrilho: "#a9d6d9" },
  { min: 50,  max: 79,       nome: "Diamante",    icone: "💎", corPrincipal: "#4fc3f7", corBrilho: "#b3e5fc" },
  { min: 80,  max: 99,       nome: "Lendário",    icone: "👑", corPrincipal: "#9b59b6", corBrilho: "#d2a6e0" },
  { min: 100, max: Infinity, nome: "Modo Deus",   icone: "⚡", corPrincipal: "#ffd700", corBrilho: "#fff9c4", brilhoIntenso: true },
];

export function getNivelTier(nivel) {
  return (
    NIVEL_TIERS.find((t) => nivel >= t.min && nivel <= t.max) || NIVEL_TIERS[0]
  );
}